import { Component, Directive, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, mergeMap, Subscription } from "rxjs";

@Directive({
  selector: "app-renter-layout",
})
export class BaseCapabilityLayout implements OnInit, OnDestroy {
  hideNavigation: boolean;
  routerSub: Subscription;

  constructor(protected router: Router, protected activatedRoute: ActivatedRoute) {
    this.routerSub = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          this.hideNavigation = false;
          while (route.firstChild && !this.hideNavigation) {
            route = route.firstChild;
            this.hideNavigation = route.snapshot.data?.hideNavigation == true;
          }

          return route;
        }),
        filter(route => route.outlet === "primary"),
        mergeMap(route => route.data),
      )
      .subscribe(data => {
        // this.hideNavigation = data?.hideNavigation == true;
      });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
